exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".select2,.select2-dropdown{font-size:1rem!important}td.dt-control{cursor:pointer}td.dt-control:before{content:\"+\";display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border:1.5px solid #5d78ff;border-radius:50%;font-size:14px;font-weight:700;color:#5d78ff;margin-right:5px;line-height:1}tr.shown td.dt-control:before{content:\"\\2212\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/BudgetPlan/BudgetPlanJobList.vue
// module id = 1045
// module chunks = 0